import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

export const useSwitchLanguageAnalytics = () => {
  const buttonClick = (location: 'header' | 'footer') => {
    logTmrEvent(
      location === 'header' ? EVENTS.headerClick : EVENTS.footerClick,
      {button_text: 'Language'},
    );
  };

  const dropdownListClick = ({
    locale,
    location,
  }: {
    locale: string;
    location: 'header' | 'footer';
  }) => {
    logTmrEvent(EVENTS.dropdownListClick, {
      button_text: `Language/${locale}`,
      location: location,
    });
  };

  return {
    buttonClick,
    dropdownListClick,
  };
};
